import type { IComponentController, IScope } from "angular";
import { finalize } from "rxjs/operators";

import type {
    ConfigurationGroupType,
    IConfigurationGroup,
    IResponseWithLoading,
    IrMap,
    ISite,
} from "App/Modules/Models";
import { ConfigurationGroupTypeFunctions } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class SiteConfigurationGroupAddComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmSitesRepository", "$translate"];

    public configurationGroup: IConfigurationGroup;

    public addResponse: IResponseWithLoading<IConfigurationGroup>;

    public configurationGroupTypes: IrMap<ConfigurationGroupType, string>;

    public resolve: IFormContainerResolve<IConfigurationGroup, ISite>;

    public site: ISite;

    constructor(
        private readonly $scope: IScope,
        private readonly sitesRepository: ISitesRepository,
        private readonly $translate: ng.translate.ITranslateService,
    ) {}

    public $onInit() {
        this.site = this.resolve.bindings;
        this.configurationGroupTypes = ConfigurationGroupTypeFunctions.GetConfigurationTypeDictionary(this.$translate);
    }

    public save() {
        extendWithLoadingAndFail(this.sitesRepository.addConfigurationGroup(this.site.id, this.configurationGroup))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (addResponse: IResponseWithLoading<IConfigurationGroup>) => {
                    this.addResponse = addResponse;
                    if (!addResponse.isLoading && addResponse.data) {
                        this.resolve.options.onOk(addResponse.data);
                    }
                },
                (errorResponse) => {
                    this.addResponse = errorResponse;
                },
            );
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }
}
